import { c as _c } from "react/compiler-runtime";
import { IcoEyeCrossed16, IcoWand16 } from '@onefootprint/icons';
import { Form, Tooltip } from '@onefootprint/ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { FormData } from '../../../playbook-settings.types';

// Internal-only feature to migrate playbooks to the modern world, where authentication and all
// settings are represented on the graph. `children` holds the rest of the migration tooling, so
// everything gated behind the migration allowlist shares one container.
const SettingsModernize = t0 => {
  const $ = _c(31);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "settingsDialog.modernize"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IcoWand16 />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex gap-2 items-center">{t2}<div className="text-label-2 text-primary">{t3}</div></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t(_temp2);
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex-shrink-0 text-tertiary"><IcoEyeCrossed16 /></div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <Tooltip content={t5} side="left">{t6}</Tooltip>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t7) {
    t8 = <div className="flex gap-2 items-center justify-between">{t4}{t7}</div>;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t(_temp3);
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t9) {
    t10 = <div className="text-body-2 text-secondary">{t9}</div>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t8) {
    t11 = <div className="flex flex-col gap-1">{t8}{t10}</div>;
    $[18] = t10;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t) {
    t12 = t(_temp4);
    $[21] = t;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12) {
    t13 = <Form.Toggle name="isModern" label={t12} size="compact" />;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t11 || $[26] !== t13) {
    t14 = <div className="flex flex-col gap-4">{t11}{t13}</div>;
    $[25] = t11;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== children || $[29] !== t14) {
    t15 = <div className="flex flex-col gap-6 p-4 rounded-lg bg-secondary">{t14}{children}</div>;
    $[28] = children;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
};
export default SettingsModernize;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.employeeOnly;
}
function _temp3($_1) {
  return $_1.description;
}
function _temp4($_2) {
  return $_2.label;
}